import apiService from '../../shared/services/apiService';

// Support requests — help / bug / feature submissions from the Help Center,
// plus demo requests from the public landing page. User-facing calls are used
// by HelpContactPage and DemoRequestModal; the admin* calls back the Support
// page in the admin console (Maestro 403s them for non-admins).

const BASE = '/v1/support-request';

const buildQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') qs.set(key, value);
  });
  const s = qs.toString();
  return s ? `?${s}` : '';
};

/** payload: { type: 'help'|'bug'|'feature', subject, description, pageContext?, projectId? } */
export async function createSupportRequest(payload, token) {
  return apiService.post(BASE, payload, token);
}

/**
 * Public — no token. payload: { name, email, phone?, company, role,
 * preferredTimes, notes?, website? } (`website` is the honeypot; leave it
 * empty). → { supportRequest: { _id, type, status, subject, createdAt } }
 */
export async function createDemoRequest(payload) {
  return apiService.post(`${BASE}/demo`, payload);
}

/** → { supportRequests } — the caller's own submissions, newest first. */
export async function listMySupportRequests(token) {
  return apiService.get(`${BASE}/mine`, token);
}

/** Admin. filters: { page, limit, type, status, search } → { supportRequests, total, page, pages, countsByStatus } */
export async function adminListSupportRequests(filters, token) {
  return apiService.get(`${BASE}${buildQuery(filters)}`, token);
}

/** Admin. payload: { status?, adminNotes? } */
export async function adminUpdateSupportRequest(id, payload, token) {
  return apiService.patch(`${BASE}/${id}`, payload, token);
}

/** Admin. */
export async function adminDeleteSupportRequest(id, token) {
  return apiService.delete(`${BASE}/${id}`, token);
}

/** Admin. → { alertTypes: ['demo', ...] } — the caller's email-alert opt-ins. */
export async function getSupportAlertPreferences(token) {
  return apiService.get(`${BASE}/alert-preferences`, token);
}

/** Admin. Full replacement; an empty array switches alerts off. → { alertTypes } */
export async function updateSupportAlertPreferences(alertTypes, token) {
  return apiService.put(`${BASE}/alert-preferences`, { alertTypes }, token);
}

export const SUPPORT_TYPE_LABELS = {
  help: 'Help request',
  bug: 'Bug report',
  feature: 'Feature request',
  demo: 'Demo request',
};

export const SUPPORT_STATUS_LABELS = {
  open: 'Open',
  in_progress: 'In progress',
  resolved: 'Resolved',
  closed: 'Closed',
};
